export interface IUserScreens {
  personalScreen: IScreenStatus;
  connectedScreens: IScreenStatus[];
}

export interface IScreenStatus {
  id: number;
  screenId: number;
  name: string;
  label: string;
  code: string;
  url: string;
  status: number;
  order: number;
}


var screenStatusType = {
  None: 1,
  Selected: 2,
  Activated: 3,
};

export default screenStatusType;

export const showScreenAsSelected = (screen: IScreenStatus) => {
  return (
    screen.status === screenStatusType.Selected ||
    screen.status === screenStatusType.Activated
  );
};

export const showScreenAsActivated = (screen: IScreenStatus) => {
  return screen.status === screenStatusType.Activated;
};

export const getScreenConnectionLabel = (screen: IScreenStatus) => {
  return screen.label ? screen.label : `S${screen.order}`;
};


